@if (orchestratorViewModel?.allViewModelInformationsBuildedList?.length > 0) {
  <div class="notification-panel">
    <div class="notification-panel-left">
      <div class="notification-panel-icon">
        <svg-icon key="info"></svg-icon>
      </div>
    </div>
    <div class="notification-panel-content" [class.expanded]="itemToShow > 1">
      @if (orchestratorViewModel?.allViewModelInformationsBuildedList?.length > 1) {
        <div class="notification-panel-top">
          <div class="notification-panel-title">
            {{
            ('std_Notification_Message' | NTSTranslate: [orchestratorViewModel?.allViewModelInformationsBuildedList?.length.toString()])
            }} @if (orchestratorViewModel?.allViewModelInformationsBuildedList.length > (itemToShow + 1)) {
            <a [routerLink]="[]" (click)="showMore()" role="button" class="notification-panel-bottom-bar-show-button">{{'std_Notification_Show_All_Message' | NTSTranslate}}</a>
          }
        </div>
      </div>
    }
    <div class="notification-panel-bottom" [class.one-notification]="orchestratorViewModel?.allViewModelInformationsBuildedList.length == 1">
      @switch (orchestratorViewModel?.allViewModelInformationsBuildedList.length) {
        @case (1) {
          <div class="notification-panel-message">
            <div class="notification-panel-message-text">
              {{ orchestratorViewModel?.allViewModelInformationsBuildedList[0].message }}
            </div>
          </div>
        }
        @default {
          @for (information of orchestratorViewModel?.allViewModelInformationsBuildedList.slice(0, itemToShow); track information) {
            <div class="notification-panel-message">
              <div class="notification-panel-message-text">
                -  {{ information.message }}
              </div>
            </div>
          }
        }
      }
      <div class="notification-panel-bottom-bar">
        @if (orchestratorViewModel?.allViewModelInformationsBuildedList.length == itemToShow && itemToShow != defaultItemToShow) {
          <a [routerLink]="[]" (click)="showLess()" role="button" class="notification-panel-bottom-bar-show-button">{{'std_Notification_Show_Less_Message' | NTSTranslate}}</a>
        }
      </div>
    </div>
  </div>
  <div class="notification-panel-right">
    <nts-text-button
      icon="cancel"
    (onClicked)="orchestratorViewModel.eventDispatcher.onNotificationBarCollapsed.next(true)"></nts-text-button>
  </div>
</div>
}